export const pluralizer = (thing: string, quantity?: number | null) => {
  const safeQuantity = quantity || 0;

  return safeQuantity === 1 ? `1 ${thing}` : `${safeQuantity} ${thing}s`;
};
